import { array, boolean, number, ord, record, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Occupancy, OccupancyData } from './occupancyTypes';

// Occupancy with negative person counts is not considered because we should never allow such Occupancy to exist.
export const isZeroPersonOccupancy = ({ occupancyData }: Occupancy) =>
    pipe(
        occupancyData,
        record.collect(string.Ord)((_key, value) => value),
        array.foldMap(number.MonoidSum)(({ personCount }) => personCount),
        (sum) => ord.leq(number.Ord)(sum, 0)
    );

export const hasOccupanciesEmptyOccupancy = (occupancies: Occupancy[]) =>
    array.isEmpty(occupancies) || pipe(occupancies, array.foldMap(boolean.MonoidAny)(isZeroPersonOccupancy));

export const hasOccupanciesNonEmptyOccupancy = (occupancies: Occupancy[]) =>
    !pipe(occupancies, array.foldMap(boolean.MonoidAll)(isZeroPersonOccupancy));

export const areAllOccupanciesZero = (occupancies: OccupancyData[]) =>
    pipe(
        occupancies,
        array.every((occupancyData) =>
            isZeroPersonOccupancy({ occupancyData: { [occupancyData.ageCategoryId]: occupancyData } })
        )
    );
